
import React from 'react';
import NavItem from './NavItem';
import { NavItem as NavItemType } from './types';

interface NavigationProps {
  navItems: NavItemType[];
  activePage: string;
  setActivePage: (page: string) => void;
  toggleSection: (section: 'publication' | 'analytics' | 'online-store' | 'social-media') => void;
}

const Navigation = ({ 
  navItems, 
  activePage, 
  setActivePage, 
  toggleSection 
}: NavigationProps) => {
  return (
    <nav className="flex-1 overflow-y-auto py-2 w-full">
      <ul className="space-y-1 w-full">
        {navItems.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            activePage={activePage}
            setActivePage={setActivePage}
            toggleSection={toggleSection}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
